$(document).ready(function(){
  $('.image-anchor').click(function(e){
    e.preventDefault();
    var id = $(this).attr('data-id');
    $('html, body').animate({
      scrollTop: $('#' + id).offset().top
    }, 800, 'swing', function(){
      window.location.hash = id;
    });
  })
});




// WEBPACK FOOTER //
// ./assets/js/blog.js